import classNames from 'classnames';
import * as React from 'react';
import { Content } from '../../interfaces';
import generateNumber from '../../utilities/customerNumber';
import request from '../../utilities/request/request';
import { DataTest } from '../../utilities/testAutomation';
import ContentContext from '../App/Context';
import PhoneIcon from '../Icons/PhoneIcon/PhoneIcon';

const Parser = require('html-react-parser');

interface Props extends DataTest {
  shouldBoxShow: boolean;
}

interface State {
  customerNumber?: string;
  hasFetched: boolean;
  isFetching: boolean;
}

class NextStep extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      customerNumber: undefined,
      hasFetched: false,
      isFetching: false,
    };
  }

  componentDidUpdate({ shouldBoxShow: prevShouldShowBox }: Props) {
    const { customerNumber, isFetching, hasFetched } = this.state;

    if (!customerNumber && !isFetching && !hasFetched) {
      this.setState({ isFetching: true });

      request({ url: 'https://api.ipify.org' })
        .then(({ data }) => this.setState({
          customerNumber: generateNumber(data),
          hasFetched: true,
          isFetching: false,
        }))
        .catch((err) => this.setState({
          customerNumber: 'error',
          hasFetched: false,
          isFetching: false,
        }));
    }
  }

  private _getNumberText = (loading: string, error: string, state?: string) => {
    if (state) {
      if (state === 'error') {
        return error;
      }
      return state;
    }
    return loading;
  }

  render() {
    const {
      shouldBoxShow,
      dataTest,
    } = this.props;
    const { customerNumber } = this.state;

    return (
      <ContentContext.Consumer>
        {(content: Content) => {
          const {
            outputs: {
              nextStep: {
                title,
                intro,
                phone,
                openingTimes,
                numberInfo,
                numberLabel,
                numberLoading,
                numberError,
                infoBox,
              },
            },
          } = content;

        const numberText = shouldBoxShow ? this._getNumberText(numberLoading, numberError, customerNumber) : undefined;

        return (
          <div className="next-step">
            <h3 className="next-step-title">{Parser(title)}</h3>
            <div className="info-box">
              {intro}
              <div className="telephone"><PhoneIcon />{Parser(phone)}</div>
              <p className="opening-times">{Parser(openingTimes)}</p>
              {shouldBoxShow && (
                <div className="text-icon-number unique-id unique-id--green">
                  <div className="unique-id__text-section"><p>{Parser(numberInfo)}</p></div>
                  <div className="unique-id__number-section">
                    <p>{numberLabel}</p>
                    <p>
                      <span
                        className={classNames('unique-id__number', {
                          'unique-id__number--loading': numberText === numberLoading,
                          'unique-id__number--error': numberText === numberError,
                        })}
                        {...dataTest}
                      >
                        {Parser(numberText)}
                      </span>
                    </p>
                  </div>
                </div>
              )}
              <div className="info-box"><p>{Parser(infoBox)}</p></div>
            </div>
          </div>
        );
        }}
      </ContentContext.Consumer>
    );
  }
}

export default NextStep;



// WEBPACK FOOTER //
// ./src/components/NextStep/NextStep.tsx